export const regionCategory = 'regions_exploration';
